import { Box, Typography } from "@mui/material";
import { ReactElement } from "react";

import PageContainer from "~frontend/components/PageContainer";
import { PageHeader } from "~frontend/components/PageHeader";
import { TableBox } from "~frontend/components/Table";
import { useBreadcrumbs } from "~frontend/providers/BreadcrumbsProvider";
import { useTenant } from "~frontend/providers/LoggedInUserProvider";

import DomainsList from "./DomainsList";
import SubaccountLinkShortenerSettings from "./SubaccountLinkShortenerSettings";

export default function Domains(): ReactElement {
  const { subaccountsEnabled } = useTenant()!;
  useBreadcrumbs([
    {
      label: "Domains",
      path: "/organization/domains",
    },
  ]);

  return (
    <PageContainer>
      <PageHeader isSlim>Link Shortening Domains</PageHeader>

      <Typography variant="h2" sx={{ mb: 2 }}>
        Enabling link shortening and custom domains allows admins to track click
        rate from links sent in your messages. To remove a custom domain, please
        reach out to our support team. To request a new domain or import your
        own, select &ldquo;Request Domain&rdquo; below.
      </Typography>

      {subaccountsEnabled && (
        <>
          <Box sx={{ mb: 4 }}>
            <Typography variant="h2">
              Each Subaccount&apos;s default settings for link shortening and
              custom domains are assigned on their Settings Page. Use the link
              below to change a subaccount&apos;s default settings.
            </Typography>
          </Box>
          <TableBox sx={{ mb: 8 }}>
            <SubaccountLinkShortenerSettings />
          </TableBox>
          <Box sx={{ mb: 2 }}>
            <Typography variant="h0Bold">Organization Domains</Typography>
          </Box>
        </>
      )}
      <DomainsList />
    </PageContainer>
  );
}
